import { useToast } from "@memorang/ui";
import { useMutation } from "@tanstack/react-query";
import NoInternetAccess from "components/NoInternetAccess";
import { getNetworkStateAsync } from "expo-network";
import { useNetworkState } from "expo-network";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const NoInternetAccessContainer = () => {
	const { isConnected } = useNetworkState();
	const { t } = useTranslation();
	const { showToast } = useToast();

	const { isPending: isChecking, mutateAsync: checkConnection } = useMutation({
		mutationKey: ["network-state"],
		mutationFn: getNetworkStateAsync,
	});

	const prevIsConnected = useRef(isConnected);
	useEffect(() => {
		if (prevIsConnected.current === false && isConnected === true) {
			showToast({
				message: t("noInternetAccess.connectionRestored"),
			});
		}
		prevIsConnected.current = isConnected;
	}, [isConnected, t, showToast]);

	if (isConnected !== false) {
		return null;
	}

	return <NoInternetAccess loading={isChecking} onRetry={checkConnection} />;
};

export default NoInternetAccessContainer;
